interface MediaItem {
  title: string;
  source: string;
  views: string;
  time: string;
  imageUrl: string;
  imageAlt: string;
}

const mediaItems: MediaItem[] = [
  {
    title: '某顶流深夜密会神秘女子，全程跟拍画面曝光引热议',
    source: '娱乐前线',
    views: '128万',
    time: '2小时前',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20paparazzi%20style%20night%20scene%20with%20silhouettes%20and%20camera%20flashes%2C%20warm%20amber%20street%20lighting%2C%20mysterious%20atmosphere%2C%20editorial%20entertainment%20news%20photography%20style%2C%20soft%20bokeh%20background%2C%20high%20contrast%2C%20cinematic%20mood&width=600&height=340&seq=media-card-01&orientation=landscape',
    imageAlt: '某顶流深夜密会神秘女子，跟拍画面曝光',
  },
  {
    title: '知名导演片场发飙怒斥演员，现场视频流出演技争议升级',
    source: '片场直击',
    views: '96万',
    time: '5小时前',
    imageUrl: 'https://readdy.ai/api/search-image?query=Film%20set%20dramatic%20moment%20with%20warm%20studio%20lighting%2C%20director%20gesturing%20intensely%2C%20abstract%20artistic%20rendering%20of%20movie%20production%20scene%2C%20amber%20and%20warm%20earth%20tones%2C%20cinematic%20atmosphere%2C%20editorial%20style%2C%20soft%20shadows&width=600&height=340&seq=media-card-02&orientation=landscape',
    imageAlt: '知名导演片场发飙怒斥演员现场',
  },
  {
    title: '某综艺录制现场突发意外，嘉宾当场翻脸罢录引全网围观',
    source: '综艺情报',
    views: '85万',
    time: '8小时前',
    imageUrl: 'https://readdy.ai/api/search-image?query=TV%20show%20recording%20studio%20with%20dramatic%20tension%2C%20bright%20stage%20lights%20and%20abstract%20silhouettes%2C%20warm%20vermillion%20and%20golden%20tones%2C%20entertainment%20news%20editorial%20style%2C%20dynamic%20composition%2C%20soft%20atmospheric%20lighting&width=600&height=340&seq=media-card-03&orientation=landscape',
    imageAlt: '综艺录制现场突发意外，嘉宾当场翻脸',
  },
  {
    title: '网红直播间意外爆料行业黑幕，多条产业链内幕浮出水面',
    source: '直播风云',
    views: '156万',
    time: '12小时前',
    imageUrl: 'https://readdy.ai/api/search-image?query=Livestreaming%20studio%20setup%20with%20dramatic%20warm%20lighting%2C%20modern%20broadcasting%20equipment%20silhouettes%2C%20abstract%20social%20media%20wave%20patterns%2C%20amber%20and%20coral%20color%20scheme%2C%20editorial%20photography%20style%2C%20high%20detail&width=600&height=340&seq=media-card-04&orientation=landscape',
    imageAlt: '网红直播间爆料行业黑幕引发热议',
  },
  {
    title: '某剧组杀青宴内幕曝光，主创团队因利益分配不欢而散',
    source: '影视内幕',
    views: '72万',
    time: '1天前',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20banquet%20scene%20with%20underlying%20tension%2C%20warm%20golden%20lighting%20and%20abstract%20figures%2C%20entertainment%20industry%20editorial%20photography%2C%20dramatic%20shadows%20and%20soft%20highlights%2C%20vermillion%20and%20amber%20color%20palette&width=600&height=340&seq=media-card-05&orientation=landscape',
    imageAlt: '某剧组杀青宴内幕曝光，主创团队不欢而散',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            吃瓜现场
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            最新视频爆料，一手现场直击，热门事件全程追踪
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.imageAlt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                    <i className="ri-play-fill text-xl text-primary-500 group-hover:text-white transition-colors"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 text-xs text-white bg-black/50 px-2 py-0.5 rounded">
                  {item.time}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-medium text-foreground-800 leading-snug line-clamp-2 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{item.source}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}